import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../../components/header';
import Footer from '../../../../components/footer';
import Head from '../../../../components/head';
import Convites from '../../../../components/contas/convites'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Convites para as Audiências Públicas de Apresentação de Metas Fiscais" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/contas/audiencias'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Convites />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;